import { css } from 'linaria';

export const certificateBlock = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: var(--background-secondary);
  border-radius: var(--rounding-l);

  &:hover {
    background-color: var(--control-minor);
  }
`;

export const certificateBlockTextContainer = css`
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0 24px;

  @media (--only-tablet) {
    padding: 0 16px;
  }

  @media (--only-mobile) {
    padding: 10px 16px;
  }
`;

export const certificateBlockTextWrapper = css`
  display: flex;
  align-items: center;

  @media (--only-desktop) {
    align-items: flex-start;
  }

  @media (--only-mobile) {
    align-items: flex-start;
  }
`;

export const certificateBlockTextIcon = css`
  && {
    @media (--only-desktop) {
      top: 4px;
    }

    @media (--to-desktop) {
      width: 20px;
      height: 20px;
    }
  }
`;

export const certificateBlockText = css`
  padding-left: 12px;

  @media (--only-mobile) {
    padding-left: 8px;
  }
`;

export const certificateBlockBanner = css`
  width: 120px;
  height: 100%;
  margin-right: 16px;

  @media (--to-desktop) {
    width: 92px;
  }
`;
